import { useEffect } from "react";
import { bool } from "prop-types";

export const UnsavedChangesPrompt = ({ hasUnsavedChanges }) => {

  // Use beforeunload event to warn users about unsaved changes
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "You have unsaved changes, are you sure you want to leave?";
        return e.returnValue;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return null;
};

UnsavedChangesPrompt.propTypes = {
  hasUnsavedChanges: bool.isRequired
};

UnsavedChangesPrompt.defaultProps = {
  hasUnsavedChanges: false
};
//note: also need to use usePreventWindowUnload hook for closing tabs
